import BaseLoadingBar from "./BaseLoadingBar.vue";

export default BaseLoadingBar;
